import { Award, Crown, Gem, Medal, Trophy } from "lucide-react";

const TIER_CONFIG = {
  bronze: {
    label: "Bronze",
    icon: Medal,
    className: "bg-[#CD7F32]/10 text-[#E9A15E] border-[#CD7F32]/40",
  },
  silver: {
    label: "Silver",
    icon: Award,
    className: "bg-slate-300/10 text-slate-200 border-slate-300/40",
  },
  gold: {
    label: "Gold",
    icon: Trophy,
    className: "bg-[#FFD700]/10 text-[#FFE066] border-[#FFD700]/40",
  },
  platinum: {
    label: "Platinum",
    icon: Gem,
    className: "bg-cyan-400/10 text-cyan-300 border-cyan-300/40",
  },
  elite: {
    label: "Elite",
    icon: Crown,
    className:
      "nexus-gradient text-white border-transparent shadow-[0_0_15px_rgba(157,78,221,0.6)]",
  },
};

export default function BadgeTier({ tier = "bronze", size = "md", showIcon = true }) {
  const cfg = TIER_CONFIG[tier] || TIER_CONFIG.bronze;
  const Icon = cfg.icon;
  const sizeCls =
    size === "sm"
      ? "text-[10px] px-2 py-0.5 gap-1"
      : size === "lg"
      ? "text-sm px-3.5 py-1.5 gap-2"
      : "text-xs px-2.5 py-1 gap-1.5";
  return (
    <span
      className={`inline-flex items-center rounded-full border font-bold uppercase tracking-widest ${cfg.className} ${sizeCls}`}
      data-testid={`badge-tier-${tier}`}
    >
      {showIcon && <Icon className={size === "lg" ? "h-4 w-4" : "h-3 w-3"} />}
      {cfg.label}
    </span>
  );
}
